export default __webpack_public_path__ + "img/Montserrat-ExtraLight_b6e37b3.woff";